var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustoms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25,0,0,1.25,-140,-140)",
    id: "Customs_Border_ENVIROTAINER"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 291.6,440.9 440.2,310.7 c -18.5,-0.1 -40.3,2.3 -59.4,1.7 -31.3,-1.1 -54.6,-10.8 -54.6,-10.8 -5.6,0 -11.6,3.3 -17,8.2 -2.7,1 -5.4,2.3 -7.8,4.2 l -76.2,61 -20.1,-53.8 c -5.1,-13.7 -20.4,-20.6 -34,-15.5 -13.7,5.1 -20.6,20.3 -15.5,34 l 32.9,88 c 3,7.9 9.6,14 17.7,16.2 2.3,0.6 4.7,1 7,1 5.9,0 11.8,-2 16.5,-5.8 L 293,388.4 Z",
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m 520.3,408.3 c 0,-37.3 -11.9,-69 -44.2,-88.9 L 319.2,456.8 462,456.5 v 22.6 l -168.8,0.3 h -0.1 -0.1 -2.7 l -1.2,41.6 h 231.7 z",
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m 480.8,181.1 c 0,0 7.3,-24.4 9.1,-28.4 -13.4,-0.2 -124,-33.3 -181.5,-40.2 -2,1.3 -0.8,27.2 3,32.7 3.5,5.1 5.7,10.6 6.5,16 -6.1,2.2 -40.9,8.8 -55.2,12.3 67.4,21.7 218.1,7.6 218.1,7.6 z",
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m 313.6,226.6 c 5.7,45.1 70.8,76.1 123.7,42.9 23.9,-15 34.7,-42 34.7,-64.5 -46.8,4 -142.7,7.1 -158.7,-7.6 -0.7,21 -2.3,8.9 0.3,29.2 z",
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m 212.9,285.8 -3.1,-12.2 25.9,-6.5 c 5.8,-1.5 9.4,-7.4 7.9,-13.2 l -24.2,-95.7 c -1.3,-4.9 -5.7,-8.2 -10.6,-8.2 -0.9,0 -1.8,0.1 -2.7,0.3 l -85.2,21.6 c -5.9,1.5 -9.4,7.4 -7.9,13.2 l 24.2,95.7 c 1.2,4.9 5.7,8.2 10.6,8.2 0.9,0 1.8,-0.1 2.7,-0.3 l 54.6,10.4 c 5.8,-1.5 9.3,-7.5 7.8,-13.3 z M 175.5,182.2 152.3,177.8 207,164 l 22.9,90.6 -23.4,5.9 -17.8,-70.4 c -1.4,-5.8 -6.8,-6.6 -13.2,-7.9 z",
    id: "path118"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustoms);
export default __webpack_public_path__ + "static/media/customs.823cdd84855a3f882e9afeda2904138c.svg";
export { ForwardRef as ReactComponent };